import { Tag, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { _Role } from "../../../js/parsegenerated";

type Props = {
  role: _Role;
};

export const RoleTag = observer((props: Props) => {
  return (
    <Tooltip
      title={props.role?.get("label")}
      placement="top"
      key={props.role?.id}
    >
      <Tag color="orange">{props.role?.get("label")}</Tag>
    </Tooltip>
  );
});
